module.exports = __webpack_public_path__ + "static/media/2_puff_1.25_87.31.d15c9112.png";